import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ actionKey, item }) => {
  switch (actionKey) {
  case 1:
    return (
      <div className="text-center">
        Are you sure you want to enable affiliate
        {' '}
        <b>{item.affiliate}</b>
        ?
      </div>
    );
  case 2:
    return (
      <div className="text-center">
        Are you sure you want to disable affiliate
        {' '}
        <b>{item.affiliate}</b>
        ?
      </div>
    );

  default:
    return null;
  }
};

Body.propTypes = {
  actionKey: PropTypes.number,
  item: PropTypes.object,
};

export default Body;
